<template>
  <div class="contractFile"></div>
</template>

<script>
  import { getContractFile } from '../request/api';
  export default {
    name: 'contractFile',
    mounted() {
      getContractFile({
        C_SIGNFLOW_ID: this.$route.query.id
      }).then(res => {
        if (res.CODE == 200) {
          window.location.href =
            'https://center.huafeng.com/ext/fileview/pdfjs/web/viewer.html?file=' +
            encodeURIComponent(res.DATA.C_FILE_DOWN_URL);
        }
      });
    }
  };
</script>

<style lang="less" scoped></style>
